import React, { useRef } from "react";
import styled from "styled-components";
import mq from "../../../helpers/media-queries";
import Sidebar from "./Sidebar";
import sections from "./sections.json";
import {
	ConfigurationContext,
	ConfigurationProvider,
} from "./ConfigurationContext";
import { SketchfabProvider } from "../../Sketchfab/SketchfabContext";
import RenderIframe from "./RenderIframe";
import modelNodes from "./modelNodes";
import { ReactComponent as RoyalTubsLogo } from "../../../assets/img/royaltubs-logo.svg";
import { useCurrentContext } from "../../../hooks/useCurrentContext";
import RenderContainer from "../../RenderContainer/RenderContainer";

const Container = styled.div`
    ${mq("sm", "min")} {
        height: 100%;
        display: flex;
    }
`;

const LogoContainer = styled.div`
    display: none;

    ${mq("desktop", "min")} {
        position: absolute;
        width: 150px;
        left: 40px;
        top: 20px;
        display: block;
    }

    svg {
        width: 100%;
    }
`;

const Headline = styled.h1`
    display: none;

    ${mq("sm", "min")} {
        font-family: "Tiempos Headline";
        position: absolute;
        padding: 24px 0;
        font-size: 30px;
        line-height: 1.3;
        color: #5b5a50;
        display: block;
    }
`;

const OfuroPage = () => {
    const viewerRef = useRef(null);
    const { addCurrentContext } = useCurrentContext();
    addCurrentContext(ConfigurationContext);

    return (
        <ConfigurationProvider>
            <SketchfabProvider
                modelUID="f1564f68788f4e7fb3de2c16aa1f0b7d"
                initialNodes={modelNodes.initial}
                viewerRef={viewerRef}
            >
                <Container>
                    <RenderContainer>
                        <LogoContainer>
                            <a href="/">
                                <RoyalTubsLogo />
                            </a>
                        </LogoContainer>
                        <Headline>Ofuro Hot Tub</Headline>
                        <RenderIframe viewerRef={viewerRef} />
                    </RenderContainer>
                    <Sidebar sections={sections} />
                </Container>
            </SketchfabProvider>
        </ConfigurationProvider>
    );
};

export default OfuroPage;
